/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Cancel Subscription?" |
*
* @param {Cancel_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_confirm_title = /** @type {((inputs?: Cancel_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler l'abonnement ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement kündigen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annullare l'abbonamento?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменить подписку?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cancelar suscripción?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("取消订阅？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションをキャンセルしますか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता रद्द करना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancelar assinatura?")
	return /** @type {LocalizedString} */ ("Cancel Subscription?")
});